<template>
  <section
    id="oppreg-landing-form">
    <material-card class="shutdown-box">
      <div class="headline black--text">
        <p class="shutdown-text">If this is  a Galaxy malfunction issues, please send an urgent email to  <a href="mailto:GuardiansoftheGalaxy@dxc.com">GuardiansoftheGalaxy@dxc.com</a>.</p>
        <p class="shutdown-text">If this is a registration issue related to funding, please send an urgent email to <a href="mailto:AWS-Oppreg@cloud.dxc.com">AWS-Oppreg@cloud.dxc.com</a></p>
      </div>
    </material-card>
    <material-card
      color="orange">
      <div class="content">
        <ol class="listStyle">
          <!-- <li class="infoblackbox">This AWS registration process applies <span class="clientworkload">solely to end customer client workloads</span></li>
          <li class="infoblackbox">To ensure understanding of which workloads and corresponding accounts are external vs internal to DXC, please download and read the document “Internal/External Definition” from the left column on this page. </li>
          <li class="infoblackbox">If your workload qualifies as internal to DXC per the referenced document “Internal/External Definition”,  exit from this Galaxy section and go to the “Request New Account” section of this Galaxy tool.</li>
          <li class="infoblackbox">Proceed here with registration for external  Client End-user opportunities</li> -->
          <li class="instruction">
            <p>
            This AWS Opportunity Registration process only applies when there is a corresponding opportunity in Salesforce. 
            If your workload does not have a Salesforce OPX, exit this Opportunity Registration and go to the Galaxy section entitled 
            “Request New Account”.
            </p>
          </li>
          <li class="instruction">
            <p>
            Before proceeding, ensure one of the following is TRUE for the Salesforce Opportunity entry:<br/>
            a. AWS Cloud Services has been selected as a Product<br/>
            OR<br/>
            b. Amazon Web Services, Inc. has been selected as a Technology Provider for the relevant Product(s)
            Without a or b in Salesforce, your registration approval will be delayed.
            </p>
          </li>
          <li class="instruction">
            <p>
              Enter the Sales Opportunity ID from Salesforce and click the “validate” button. When you select “continue”, Galaxy pulls in the basic opportunity and account information from Sales force automatically on the next Galaxy app pages.
            </p>
          </li>
          <li class="instruction">
            <p>
              If Salesforce or SF API is not functioning, you have the option to enter all opportunity and account information manually. Click the "Manual Input" button to proceed manually.
            </p>
          </li>
        </ol>
        <v-layout row>
          <v-text-field
            v-validate="'required|alpha_dash'"
            :error-messages="errors.collect('searchId')"
            :success-messages="oppIdValidatedMessage"
            v-model.trim="searchId"
            :loading="validatingOppId"
            data-vv-name="searchId"
            solo
            placeholder="Enter OPPID to be registered:"
            clearable
            @keyup.enter="onOppIdValidate">
            <template v-slot:append>
              <v-btn
                class="my-0"
                small
                @click="onOppIdValidate"
                :disabled="!searchId"
              >
                <span v-if="disableContinue">validate</span>
                <v-icon
                  v-else
                  small>check</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-layout>
        <div class="d-inline-flex align-center">
          <v-icon>mdi-information-outline</v-icon>&nbsp;
          <p class="my-0">Salesforce Datalake API may cause delay and sometimes will throw a timeout error. In case of timeout error, you can proceed with manual input after the validation.</p>
        </div>
        <v-layout row v-if="edlConnectionTimeout">
          <v-alert
            :value="true"
            type="warning"
            class="py-0"
          >
            If OPX validation is not functioning, please click <v-btn
            @click="continueManualRegistration">HERE</v-btn> to proceed to next page for manual opportunity input
          </v-alert>
        </v-layout>
        <!-- <v-checkbox
          v-if="type==='new'"
          v-model="noOppId"
          :disabled="verification"
          light
          background-color: black
          class="mx-2 confirm-validation"
          color="primary"
          label="I do not have an OPID for this registration due to internal DXC workloads or subsidiary/affiliate workloads."
          @change= "isNoOppIdChange()"
        />
        <v-radio-group
          v-show="noOppId"
          v-model="noOppIdType"
          class="ml-4 mt-0">
          <label>My Opportunity is for:</label>
          <v-radio
            color="orange"
            label="DXC Internal"
            value="internal"
          />
          <v-radio
            color="orange"
            label="DXC Subsidiary or Affiliate"
            value="subsidiary"
          />
          <v-radio
            color="orange"
            label="Gainwell Technologies"
            value="gainwell"
          />
        </v-radio-group> -->
        <div class="text-md-right">
          <v-btn
            class="success"
            @click="continueManualRegistration">Manual Input</v-btn>
          <router-link to="/" tag="v-btn">EXIT</router-link>
          <v-btn
            :disabled="disableContinue"
            class="success"
            @click="continueRegistration">CONTINUE</v-btn>
        </div>
      </div>
    <!-- </v-container> -->
    </material-card>
  </section>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      default: 'new',
      inputTimeout: null
    }
  },
  data () {
    return {
      verification: false,
      noOppId: false,
      noOppIdType: ''
    }
  },
  computed: {
    ...mapState('user/requestOppreg', ['sfdcId', 'validatingOppId', 'oppIdValidated', 'submitting', 'formSubmitting', 'isSubmitted', 'recordNotFound', 'edlConnectionTimeout']),
    searchId: {
      get () {
        return this.sfdcId
      },
      set (id) {
        this.$store.commit('user/requestOppreg/setSfdcId', id)
      }
    },
    // disableOppIdInput () {
    //   return !this.verification
    // },

    oppIdValidatedMessage() {
      return this.oppIdValidated ? 'Valid Opportunity ID. You can now procced to the next step by clicking the Continue button' : ''
    },
    
    disableContinue () {
      return !(this.errors.items.length === 0 && this.searchId && this.oppIdValidated && !this.validatingOppId && !this.recordNotFound)
      
    }
  },
  mounted () {
    this.$store.commit('user/requestOppreg/setValidatedOpp', false)
    this.$store.commit('user/requestOppreg/setCustomId', false)
    this.$store.commit('user/requestOppreg/toggleManualRegOption', false)
    this.$store.commit('user/requestOppreg/removeManualRegistration')
  },
  methods: {
    onOppIdValidate () {
      // clearTimeout(this.inputTimeout)
      var self = this
      console.log('validating opp id: ' + self.type)
        if (self.type === 'new') {
          self.$store.dispatch('user/requestOppreg/validateOppId', self.searchId)
        } else if (self.type === 'existing') {
          self.$store.dispatch('user/requestOppreg/validateExistingOppId', self.searchId)
        }
      // }, 1000)
    },
    isNoOppIdChange(){
      console.log('isNoOppId: '+ this.noOppId )
      if(this.noOppId === true){
        this.$store.commit('user/requestOppreg/clearOpportunityRecord')
      }
    },
    continueRegistration () {
      if (this.noOppId) {
        this.$store.commit('user/requestOppreg/setOppType', this.noOppIdType)
      }
      this.$emit('continue')
    },

    continueManualRegistration () {
      this.$store.commit('user/requestOppreg/setManualRegistration', this.searchId)
      this.$store.commit('user/requestOppreg/setCustomId', true)
      this.$emit('continue')
    }
  }
}
</script>
<style lang="scss" scoped>
#oppreg-landing-form {
  padding: 15px;
  .content {
    >p {
      font-size: 16px !important;
    }
    .infoblackbox {
      background: black;
      color:  white;
      font-weight: bold;
      margin-bottom: 1em;
      padding: .7em;
      list-style-position: inside;
    }
    .clientworkload {
      text-decoration: underline;
      text-decoration-thickness: 3px;
      text-underline-position: under;

    }
    .confirm-validation /deep/ label{
      color: black !important;
    }

    .instruction {
      font-size: 20px !important;
      font-weight: bold;
      margin-bottom: 30px;
      >p {
         margin-left: 15px;
         font-size: 20px !important;
         font-weight: bold;
      }
    }
    .listStyle {
      padding-left: 0;
      margin-left: 25px;
      margin-bottom: 50px;
    }
}
.shutdown-box {
  background-color: antiquewhite !important;
}
.shutdown-text {
  font-size: 16px !important;
  font-weight: bold;
  color: #000 !important;
  margin-bottom: 0px !important;
  }
}
</style>
